// extracted by mini-css-extract-plugin
export default {"wrapper":"panel-module--wrapper--c6826","icon":"panel-module--icon--f8171"};